import React, { useState, useEffect } from "react";
import {
  Link,
} from "react-router-dom";
import { withRouter } from "react-router";

import AudienceSearchFormat from "./audienceSearchFormat";

import { searchesService } from '../../services/searches';


// shows search bar for within audience. Also shows recent searches.
const AudienceSearch = ({
  collection,
  history,
  searchSuggestions,
}) => {
  const [keyword, setKeyword] = useState('');
  const [recentSearches, setRecentSearches] = useState([]);
  const [loadingRecentSearches, setLoadingRecentSearches] = useState(false);

  // effects
  useEffect(() => {
    // fetch recent searches in this audience
    fetchRecentSearches();
  }, []);

  const fetchRecentSearches = () => {
    setLoadingRecentSearches(true)
    searchesService.recentSearches({'collection': collection.hash}, (results) => {
      if (results && results.data){
        setRecentSearches(results.data)
        setLoadingRecentSearches(false)
      }
    }, () => {
      setLoadingRecentSearches(false)
    })
  }

  const performSearch = (e) => {
    e.preventDefault()
    history.push(`/audience/${collection.hash}/search/?keyword=${encodeURIComponent(keyword)}`);
    setKeyword(''); // clear the form when we open the drawer
  }

  // unique searches for keywords (just 1 keyword, not multiple)
  const recentSearchesToShow = Array.from(new Set(recentSearches.filter(s => s.params.keyword && !s.params.keyword.includes(',')).map(s => s.params.keyword)));

  return (
    <div className="flex-1 mt-4 sm:mt-0">
      <label className="text-lg font-medium">
        Keyword Search
      </label>

      <div className="mt-2 relative text-gray-400 focus-within:text-white">
        <form onSubmit={performSearch}>
          <input id="keyword-search" type="text" placeholder="Keyword search in audience" autoComplete="off" spellCheck="off" autoFocus="on"
            className="text-sm sm:text-base block bg-gray-800 w-full border-transparent p-4 pl-12 placeholder-gray-500 rounded-md focus:border-transparent focus:ring-0"
            disabled={!collection}
            value={keyword} onChange={(e) => {
              setKeyword(e.target.value);
            }}
          />
        </form>
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center justify-center pl-4">
          <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
          </svg>
        </div>
      </div>

      <div className="flex flex-wrap">
        <AudienceSearchFormat />

        {recentSearchesToShow.map(k => (
          <Link key={k} to={`/audience/${collection.hash}/search/?keyword=${encodeURIComponent(k)}`}
            className={`mt-2 mr-2 p-1 text-xs text-white border ${keyword === k ? 'bg-gray-700 border-gray-600' : 'hover:bg-gray-800 border-gray-700'} cursor-pointer rounded-md flex items-center`}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-4 w-4 mr-1 opacity-25">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>

            <div>{k}</div>
          </Link>
        ))}

        {searchSuggestions && searchSuggestions.length && recentSearchesToShow.length <= 3 ? (
          <React.Fragment>
            {searchSuggestions.filter(k => !recentSearchesToShow.includes(`title:"${k}"`)).map(k => (
              <Link key={k} to={`/audience/${collection.hash}/search/?keyword=title:"${encodeURIComponent(k)}"`}
                className={`mt-2 mr-2 p-1 text-xs text-white border ${keyword === k ? 'bg-gray-700 border-gray-600' : 'hover:bg-gray-800 border-gray-700'} cursor-pointer rounded-md flex items-center`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-4 w-4 mr-1 opacity-25">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
                </svg>
                <div>{k}</div>
              </Link>
            ))}
          </React.Fragment>
        ) : ''}

      </div>
    </div>
  )
}

export default withRouter(AudienceSearch);

